import { hasCapability, type User } from "../base";

export const calendar = {
  read: (user: User) => hasCapability(user, "calendar.read"),
  /**
   * Without `contractorId`, only the capability is checked (legacy callers).
   * With `contractorId`, additionally requires `calendar.create.all` (Remi
   * staff) or that the caller belongs to that contractor org.
   */
  create: (user: User, contractorId?: string) => {
    if (!hasCapability(user, "calendar.create")) {
      return false;
    }
    if (contractorId === undefined) {
      return true;
    }
    return hasCapability(user, "calendar.create.all") || user.person.organizationId === contractorId;
  },
  delete: (user: User) => hasCapability(user, "calendar.delete"),
};
